///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { Component, ViewChild } from '@angular/core';
import { KbNumericInputBaseComponent } from './../numeric-input.base.component';
import { NumericTextBoxComponent } from '@progress/kendo-angular-inputs';

@Component({
    selector: 'kb-percent-value-text-box',
    templateUrl: './percent-value-text-box.component.html',
})
export class KbPercentValueTextBoxComponent extends KbNumericInputBaseComponent {
    @ViewChild('percentValueInput')
    public percentValueInput: NumericTextBoxComponent;
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/percent-value-text-box/percent-value-text-box.component.ts